import axios from "axios";
import {API_URL} from "../context/GlobalConstants";

const API = axios.create({
    baseURL: API_URL,
});

// Attach JWT to every request if available
API.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// LOGIN
export const login = async (email, password) => {
    const { data } = await API.post("/login", { email, password });
    localStorage.setItem("token", data.token); // store JWT
    return data;
};

// LOGOUT
export const logout = () => {
    localStorage.removeItem("token");
};

// REGISTER
export const register = async (email, password) => {
    const { data } = await API.post("/register", { email, password });
    localStorage.setItem("token", data.token); // save token same as login
    return data;
};

export const getFromApi = async (path) => {
    try {
        const { data } = await API.get(`/${path}`);
        return data;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
}

export const postToApi = async (path, payload) => {
    try {
        const { data } = await API.post(`/${path}`, payload);
        return data;
    } catch (error) {
        console.error("Error posting data:", error);
        throw error;
    }
}

export const deleteFromApi = async (path) => {
    try {
        const { data } = await API.delete(`/${path}`);
        return data;
    } catch (error) {
        console.error("Error deleting data:", error);
        throw error;
    }
}

export const patchToApi = async (path, payload) => {
    try {
        const { data } = await API.patch(`/${path}`, payload);
        return data;
    } catch (error) {
        console.error("Error patching data:", error);
        throw error;
    }
}

export const putToApi = async (path, payload) => {
    try {
        const { data } = await API.put(`/${path}`, payload);
        return data;
    } catch (error) {
        console.error("Error updating data:", error);
        throw error;
    }
}

export const uploadToApi = async (path, formData, onProgress) => {
    try {
        const { data } = await API.post(`/${path}`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
            onUploadProgress: onProgress
                ? (e) => onProgress(Math.round((e.loaded * 100) / (e.total || 1)))
                : undefined,
        });
        return data;
    } catch (error) {
        console.error("Error uploading:", error);
        throw error;
    }
};

export const getApiUrl = () => API_URL;

// GET USER
export const getUser = async () => {
    try {
        const { data } = await API.get("/me");
        return data;
    } catch {
        return null;
    }
};

